export default __webpack_public_path__ + "static/media/porter.b8fc59eb.png";